import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen text-slate-100">
      <main className="mx-auto flex min-h-screen max-w-lg items-center justify-center px-4">
        <div className="w-full rounded-2xl border border-slate-800 bg-slate-900/60 p-8 text-center">
          <XCircle className="mx-auto h-16 w-16 text-slate-400" />
          <h1 className="mt-4 text-2xl font-bold">Pagamento annullato</h1>
          <p className="mt-2 text-slate-400">Nessun addebito e stato effettuato.</p>
          <Button
            onClick={() => nav("/")}
            data-testid="cancel-back-home"
            className="mt-6 w-full bg-cyan-400 text-slate-950 hover:bg-cyan-300"
          >
            Torna alla home
          </Button>
        </div>
      </main>
    </div>
  );
}
